export default __webpack_public_path__ + "static/media/14.813a30e2.png";